/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_Col_PlayerInputs */



/**
* | output |
* | --- |
* | "Player" |
*
* @param {Rankings_Col_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_col_player = /** @type {((inputs?: Rankings_Col_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Col_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giocatore")
	return /** @type {LocalizedString} */ ("Player")
});